"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPClient = void 0;
const middlewares_1 = require("./middlewares");
const UserAgent = "user-agent";
const ContentType = "content-type";
const ApplicationJson = "application/json";
class HTTPClient {
    baseUrl;
    name;
    middlewares;
    constructor(baseUrl, name, middlewares = []) {
        this.baseUrl = baseUrl;
        this.name = name;
        this.middlewares = middlewares;
        middlewares.push(new middlewares_1.FetchMiddleware());
    }
    send(config) {
        if (this.middlewares.length === 0)
            throw new Error("No middleware were added");
        const request = this.buildRequestObject(config);
        let index = 0;
        const runner = () => {
            return this.middlewares[index++].onRequest(request, runner);
        };
        return runner().then(r => r.body);
    }
    buildRequestObject(request) {
        let path = request.path;
        if (request.params) {
            for (const param in request.params) {
                path = path.replaceAll(`:${param}`, request.params[param]);
            }
        }
        request.url = new URL(path, this.baseUrl);
        if (request.query) {
            for (const name in request.query) {
                const value = request.query[name];
                if (value === undefined)
                    continue;
                request.url.searchParams.set(name, Array.isArray(value) ? value.join(",") : value);
            }
        }
        if (request.body && !(request.body instanceof FormData))
            request.headers = { [UserAgent]: this.name, [ContentType]: ApplicationJson, ...request.headers };
        else
            request.headers = { [UserAgent]: this.name, ...request.headers };
        return request;
    }
}
exports.HTTPClient = HTTPClient;
//# sourceMappingURL=client.js.map